var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCarbonIntensityLowIcon = function SvgCarbonIntensityLowIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 90,
    viewBox: "0 0 71 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M39.4802 32H29.9868V80.3211H39.4802V32Z",
    fill: "#0A9928"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M58.4667 80.3209H11V89.8142H58.4667V80.3209Z",
    fill: "#0A9928"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1474 34.0099L34.6002 0L27.053 34.0099L1.37354 57.5533L34.6002 47.0869L67.8269 57.5533L42.1474 34.0099Z",
    fill: "#0A9928"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.49333 37.9733C9.49333 28.385 14.7147 20.0071 22.428 15.4741L24.9675 4.01086C10.5139 8.5202 0 22.0482 0 37.9733C0 40.7263 0.356 43.4082 0.949333 45.9714L9.49333 38.1394C9.49333 38.0682 9.49333 38.0207 9.49333 37.9733Z",
    fill: "#0A9928"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M60.7073 37.9736C60.7073 38.0211 60.7073 38.0686 60.7073 38.1398L69.2751 45.9955C69.8447 43.4086 70.2007 40.7267 70.2007 37.9736C70.2007 22.0486 59.6868 8.52058 45.2095 3.98752L47.7489 15.4507C55.486 20.0075 60.7073 28.3854 60.7073 37.9736Z",
    fill: "#0A9928"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCarbonIntensityLowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "carbon_intensity_low_icon.3d3bacef2356d52398f590c36e45c628.svg";